module.exports = __webpack_public_path__ + "img/29.7bc4cacc.png";